import React, { useEffect, useState } from "react";
import { Panel, Field } from "@/pages/admin/shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Save, Plus, Trash2, Facebook, Instagram, Twitter, Linkedin, Youtube, Github, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/pages/admin/api";

const PLATFORM_ICONS = {
  facebook: Facebook, instagram: Instagram, twitter: Twitter, linkedin: Linkedin,
  youtube: Youtube, github: Github, telegram: Send,
};

export default function SocialMedia() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/socials").then((r) => setItems(r.data)); }, []);

  const set = (idx, key, value) => {
    const next = [...items];
    next[idx] = { ...next[idx], [key]: value };
    setItems(next);
  };
  const add = () => setItems([...items, { platform: "facebook", url: "", enabled: true }]);
  const del = (idx) => setItems(items.filter((_, i) => i !== idx));

  const save = async () => {
    setSaving(true);
    try {
      const cleaned = items.map((i) => ({
        id: i.id, platform: (i.platform || "").toLowerCase().trim(), url: i.url, enabled: !!i.enabled,
      }));
      const r = await api.put("/socials", cleaned);
      setItems(r.data);
      toast.success("Social links updated");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <Panel
      title="Social Media Links"
      subtitle="Enable, disable and edit social profiles. Header and Footer read from these values."
      actions={
        <>
          <Button variant="outline" onClick={add} className="rounded-xl"><Plus size={14} className="mr-1" /> Add</Button>
          <Button data-testid="save-socials" onClick={save} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><Save size={14} className="mr-1" /> {saving ? "Saving..." : "Save"}</Button>
        </>
      }
    >
      <div className="space-y-3">
        {items.map((s, i) => {
          const Icon = PLATFORM_ICONS[(s.platform || "").toLowerCase()] || Facebook;
          return (
            <div key={s.id || i} className="grid md:grid-cols-[36px_1fr_2fr_120px_36px] gap-3 items-end rounded-xl border border-border p-3">
              <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950/40 text-blue-600 grid place-items-center"><Icon size={16} /></div>
              <Field label="Platform">
                <Input value={s.platform} onChange={(e) => set(i, "platform", e.target.value)} placeholder="facebook / twitter / linkedin" />
              </Field>
              <Field label="URL"><Input value={s.url} onChange={(e) => set(i, "url", e.target.value)} placeholder="https://..." /></Field>
              <Field label="Enabled">
                <label className="flex items-center gap-2 h-10">
                  <Checkbox checked={!!s.enabled} onCheckedChange={(v) => set(i, "enabled", !!v)} />
                  <span className="text-xs text-muted-foreground">{s.enabled ? "Visible" : "Hidden"}</span>
                </label>
              </Field>
              <button onClick={() => del(i)} className="text-red-500 hover:opacity-70 p-2"><Trash2 size={14} /></button>
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
